<section class="pl-pane__nav pl-pane--condense-left show-only@desktop">
  <div pl-grid="tight spaced align-middle">
    <div pl-grid-el pl-grid="shrink@phone">
      <se-fe-back-button (click)="navigate()">back</se-fe-back-button>
    </div>
  </div>
</section>
